/*
 *
 * MyBookings constants
 *
 */

export const DEFAULT_ACTION = '/MyBookings/DEFAULT_ACTION';
export const FETCH_USER_BOOKINGS_SUCCESS = '/MyBookings/FETCH_USER_BOOKINGS_SUCCESS';

export const DEFAULT_PRE_PAYLOAD = {
  first_offset: 0,
  last_offset: 10,
};



// WEBPACK FOOTER //
// client/containers/MyBookings/constants.js